module.exports = __webpack_public_path__ + "static/media/shareTable.06ea633e.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/feature/ios/shareTable.gif
 ** module id = 609
 ** module chunks = 0
 **/